export default "__VITE_ASSET__05f32ad4__"